export const CATALOG_STATUS_CODES = ['DRAFT', 'PUBLISHED', 'PAUSED', 'DELETED'];

export const catalogStatusColors = {
  DRAFT: 'default',
  PUBLISHED: 'success',
  PAUSED: 'warning',
  DELETED: 'error',
};

export const catalogStatusI18nKey = (code) => {
  const c = String(code || 'DRAFT').toUpperCase();
  return `catalog.status_${c.toLowerCase()}`;
};
